import {permitApplicationFieldsUtil} from "permitapplication/utilities";

const permitUtil = permitApplicationFieldsUtil;
const createNotifications = permitUtil.createNotifications;

const getTypesStepRequiredFields = extension => {
    const fieldsByType = {
        felling: [
            [
                "Selecione as árvores que serão incluídas na prorrogação de abate.",
                permitUtil.checkElements(
                    extension?.tree_set,
                    "felling",
                    "is_felling_extended"
                ),
            ],
        ],
        cutting: [
            [
                "Selecione as árvores e os toros que serão incluídos na prorrogação de serragem.",
                permitUtil.checkElements(
                    extension?.tree_set,
                    "cutting",
                    "is_cutting_extended"
                ),
            ],
        ],
        transport: [
            [
                "Selecione os materiais que serão transportados na prorrogação.",
                permitUtil.checkElements(extension?.material_set, "is_extended"),
            ],
        ],
        clearing: [
            [
                "Acrescente a área a desbravar na prorrogação.",
                !!extension?.clearing_area,
            ],
        ],
    };

    const typesNotifications =
        extension?.types?.flatMap(type =>
            fieldsByType[type] ? createNotifications(fieldsByType[type]) : []
        ) || [];

    const hasMissingDates = extension?.types?.some(
        type => !extension[`${type}_start_date`] || !extension[`${type}_end_date`]
    );

    const datesNotifications = hasMissingDates
        ? createNotifications([["Acrescente as datas da prorrogação.", false]])
        : [];

    const requiredFields = [...datesNotifications, ...typesNotifications];

    return requiredFields;
};

const getReportStepFields = extension =>
    createNotifications([
        ["Indique o parecer técnico.", !!extension.technical_decision],
    ]);

const getFeesStepRequiredFields = extension => {
    // return createNotifications([
    //     ["Indique o valor pago da prorrogação.", !!extension.fee_type],
    // ]);
    return [];
};

const getInvoiceStepFields = extension =>
    createNotifications([
        // ["Imprima a factura.", !!extension.printed_invoice],
        [
            "Indique si a factura foi enviada para o/a titular.",
            !!extension.invoice_sent,
        ],
    ]);

const getSignatureStepFields = extension =>
    createNotifications([
        ["Imprima a prorrogação.", !!extension.printed_extension],
        [
            "Indique si a prorrogação foi enviada para a Direcção.",
            !!extension.extension_sent,
        ],
        ["Indique si a Direcção assinou a prorrogação.", !!extension.extension_signed],
    ]);

export const getRequiredFields = permit => ({
    pendente_guias_e_datas: getTypesStepRequiredFields(permit),
    report_m: getReportStepFields(permit),
    payment_e: getFeesStepRequiredFields(permit),
    invoice_s: getInvoiceStepFields(permit),
    signature_s: getSignatureStepFields(permit),
});
